module.exports = __webpack_public_path__ + "67050a4b66d25d217f369d3200f23859.fbx";